<template>
<!-- 关于我们 -->
    <div class="coordinates">
        <coordHeader></coordHeader>
        <coordMain></coordMain>
        <coordCorporate></coordCorporate>
        <paheFooter></paheFooter>
    </div>
</template>

<script>
import coordHeader from '@/common/coordinates/coord-header'
import coordMain from '@/common/coordinates/coord-main'
import coordCorporate from '@/common/coordinates/coord-corporate'
import paheFooter from '@/common/index/pahe-footer'
export default {
    name: 'coordinates',
    components:{
        coordHeader,
        paheFooter,
        coordMain,
        coordCorporate
    },
    mounted() {
        var coordinates = localStorage.getItem('coordinates');
        document.documentElement.scrollTop = coordinates;
    },
    destroyed() {
        let i1 = document.documentElement.scrollTop;
        localStorage.setItem('coordinates', i1)
    },
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/coordinates.vue